import { render, staticRenderFns } from "./StzhUnprotectedViewFooter.vue?vue&type=template&id=164ad1da"
import script from "./StzhUnprotectedViewFooter.vue?vue&type=script&lang=js"
export * from "./StzhUnprotectedViewFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports